import axios from "axios";
import NProgress from "nprogress";
import router from "@/router"; // make sure this path is correct

const API_URL = process.env.VUE_APP_APIADMINURL;

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

function clearAuthSession() {
  localStorage.removeItem("user");
  localStorage.removeItem("jwt_token");
  sessionStorage.removeItem("user");
  delete axiosInstance.defaults.headers.common.Authorization;
}

function redirectToLogin() {
  const routeName = router.currentRoute.value?.name;
  if (routeName === "login" || routeName === "reset-password") return;
  router.push({ name: "login" });
}

axiosInstance.interceptors.response.use(
  (response) => {
    NProgress.done();

    if (
      response?.data?.success === false &&
      response?.data?.errors?.error_code === 1020
    ) {
      clearAuthSession();
      redirectToLogin();
    }

    return response;
  },
  (error) => {
    NProgress.done();

    const routeName = router.currentRoute.value?.name;
    const isAuthForm = routeName === "login" || routeName === "reset-password";

    if (error.response?.status === 401 && !isAuthForm) {
      clearAuthSession();
      redirectToLogin();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
